export class CompanyModel {
  public id!: number;
  public name!: string;
  public website!: string;
  public integrations!: number[];

  constructor() {
    this.id = 0;
    this.name = "";
    this.website = "";
    this.integrations = [];
  }
}
